var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_824_6743",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 30,
    height: 30
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_824_6743)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.3557 25.1925L16.5288 17.3657C15.9038 17.8977 15.1851 18.3096 14.3726 18.6013C13.5601 18.893 12.7436 19.0388 11.9232 19.0388C9.92112 19.0388 8.22664 18.3458 6.83977 16.9597C5.4531 15.5737 4.75977 13.8802 4.75977 11.8794C4.75977 9.87837 5.45279 8.18348 6.83883 6.79473C8.22487 5.40618 9.91831 4.71191 11.9191 4.71191C13.9202 4.71191 15.6151 5.40525 17.0038 6.79191C18.3924 8.17879 19.0866 9.87327 19.0866 11.8754C19.0866 12.7439 18.9328 13.5844 18.6251 14.3969C18.3174 15.2094 17.9135 15.9041 17.4135 16.481L25.2404 24.3082L24.3557 25.1925ZM11.9232 17.7888C13.5817 17.7888 14.982 17.2179 16.1238 16.076C17.2657 14.9343 17.8366 13.5341 17.8366 11.8754C17.8366 10.2166 17.2657 8.81639 16.1238 7.67473C14.982 6.53285 13.5817 5.96191 11.9232 5.96191C10.2645 5.96191 8.86424 6.53285 7.72258 7.67473C6.5807 8.81639 6.00977 10.2166 6.00977 11.8754C6.00977 13.5341 6.5807 14.9343 7.72258 16.076C8.86424 17.2179 10.2645 17.7888 11.9232 17.7888Z",
    fill: "#232323"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.c7acb5fc3d9f4c3e1b90739bed2a2f38.svg";
export { ForwardRef as ReactComponent };